import { render, staticRenderFns } from "./modNavLink.vue?vue&type=template&id=644e2cde&"
import script from "./modNavLink.vue?vue&type=script&lang=js&"
export * from "./modNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports